import React from 'react'
import { useConfigStore } from '@renderer/stores/configState'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text: React.ReactNode
  variant?: 'primary' | 'secondary'
  fullWidth?: boolean
}

const Button: React.FC<ButtonProps> = ({
  text,
  variant = 'primary',
  fullWidth = false,
  className = '',
  style,
  ...props
}) => {
  const { config } = useConfigStore()
  const { primaryColor, secondaryColor } = config?.theme || {
    primaryColor: '#3B82F6',
    secondaryColor: '#FFFFFF'
  }

  const baseClasses = `
    rounded-full
    font-medium
    transition-all
    duration-500
    select-none
    active:scale-95
    hover:opacity-90
    focus:outline-none
    focus:ring-2
    focus:ring-offset-2
    disabled:opacity-50
    disabled:cursor-not-allowed
    px-[clamp(1.5rem,3vw,3rem)]
    py-[clamp(0.75rem,1.5vw,1rem)]
    text-[clamp(1.2rem,2vw,1.5rem)]
    ${fullWidth ? 'w-full' : ''}
  `

  const buttonStyle = {
    ...style,
    backgroundColor: variant === 'primary' ? primaryColor : secondaryColor,
    color: variant === 'primary' ? secondaryColor : primaryColor,
    border: variant === 'secondary' ? `1px solid ${primaryColor}` : 'none'
  }
  return (
    <button
      type="button"
      className={`${baseClasses} ${className} transition-transform transform shadow-xl active:scale-95`}
      style={buttonStyle}
      {...props}
    >
      {text}
    </button>
  )
}

export default Button
